import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const ClubReview: FC = () => {
  const { t } = useContext(LocalizationContext);

  const isAvailable = useIsFeatureAvailable('club_review');

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        label={t('setting.reviews')}
        description={t('settings.shell.client.reviews.description')}
        value={settings.feedbackEnabled}
        onChange={(value: string) => {
          setSetting({
            alias: ESettingsAliases.FEEDBACK_ENABLED,
            value: value ? '1' : '0',
          });
        }}
        variant="secondary"
        emptyBg
        disabled={!isAvailable}
        rightContent={!isAvailable ? <SettingsLock /> : undefined}
      />
    </>
  );
};
